import { useCallback } from 'react';
import {
  useQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  OperationVariables,
  QueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AdvertiserForAddMarketplace.graphql';
import { Query } from '../../__generated__/globalTypes';

export const useAdvertiserForAddMarketplaceQuery = (options?: QueryHookOptions<Query>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAdvertiserForAddMarketplaceLazyQuery = (
  options?: LazyQueryHookOptions<Query>
): QueryResult<Query> & { getAdvertiserForAddMarketplaceQuery: LazyQueryExecFunction<Query, OperationVariables> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  // TODO: should be getAdvertiserForAddMarketplace
  const [getAdvertiserForAddMarketplaceQuery, result] = useLazyQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAdvertiserForAddMarketplaceQuery, ...result };
};

export const useAdvertiserForAddMarketplacePromiseQuery = () => {
  const client = useApolloClient();

  const getAdvertiserForAddMarketplace = useCallback(
    (options?: Omit<QueryOptions<Record<string, unknown>, Query>, 'query'>) =>
      client.query<Query>({ ...options, query: QUERY }),
    [client]
  );

  return { getAdvertiserForAddMarketplace };
};
